define.alias("shared/components/shared/modal/navigation", "settings/components/shared/modal/navigation");